'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validateUrlDecOctet = require('./validateUrlDecOctet');

var _validateUrlDecOctet2 = _interopRequireDefault(_validateUrlDecOctet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validateUrlIpv4 = (0, _regexSupplant2.default)(/(?:#{validateUrlDecOctet}(?:\.#{validateUrlDecOctet}){3})/i, {
  validateUrlDecOctet: _validateUrlDecOctet2.default
});

exports.default = validateUrlIpv4;
module.exports = exports['default'];